import {
    LogLevel,
    SimliClient
}
from "simli-client";

import {
    JWT
}
from "../../../../constants/local-storage";


//========================================================
// Eva Simli Service
//
// Handles creation and management of the Simli avatar
// connection.
//
// Simli is the rendering layer only.
//========================================================


//========================================================
// Create Simli Session Token
//========================================================

async function createSessionToken()
{

    //----------------------------------------------------
    // Call OmniScan Backend
    //----------------------------------------------------

    const response =
        await fetch(
            "/resolutionsoftwareplatform/eva/simli/session",
            {
                method:
                    "POST",

                headers:
                {
                    "Authorization":
                        localStorage.getItem(
                            JWT
                        ),

                    "Accept":
                        "application/json",

                    "Content-Type":
                        "application/json"
                }
            }
        );


    //----------------------------------------------------
    // Read Response
    //----------------------------------------------------

    const responseText =
        await response.text();


    console.log(
        "SIMLI SESSION STATUS:",
        response.status
    );


    //----------------------------------------------------
    // Validate Response
    //----------------------------------------------------

    if (!response.ok)
    {

        throw new Error(
            "Unable to create Simli session: "
            + response.status
            + " - "
            + responseText
        );

    }


    //----------------------------------------------------
    // Parse Response
    //----------------------------------------------------

    const data =
        JSON.parse(
            responseText
        );


    //----------------------------------------------------
    // Validate Token
    //----------------------------------------------------

    if (!data.session_token)
    {

        throw new Error(
            "Simli did not return a session token."
        );

    }


    //----------------------------------------------------
    // Return Token
    //----------------------------------------------------

    return data.session_token;

}


//========================================================
// Create Simli Client
//========================================================

export async function createSimliClient(
    videoElement,
    audioElement
)
{

    //----------------------------------------------------
    // Validate Media Elements
    //----------------------------------------------------

    if (
        !videoElement ||
        !audioElement
    )
    {

        throw new Error(
            "Eva video elements are not available."
        );

    }


    //----------------------------------------------------
    // Create Temporary Session Token
    //----------------------------------------------------

    const sessionToken =
        await createSessionToken();


    console.log(
        "SIMLI SESSION TOKEN RECEIVED"
    );


    //----------------------------------------------------
    // Create Client
    //----------------------------------------------------

    const simliClient =
        new SimliClient(
            sessionToken,
            videoElement,
            audioElement,
            null,
            LogLevel.DEBUG,
            "livekit"
        );


    //----------------------------------------------------
    // Return Client
    //----------------------------------------------------

    return simliClient;

}


//========================================================
// Stop Simli Client
//========================================================

export async function stopSimliClient(
    simliClient
)
{

    if (!simliClient)
    {
        return;
    }


    await simliClient.stop();

}